import { FC, useState } from 'react';
import { CancelToken } from 'axios';
import { useTranslation } from 'react-i18next';
import { Segment, SegmentType } from '~src/interfaces/segment.interface';

import PeopleChips from '~src/modules/surveys/components/schedules/scheduleItem/templates/sections/customInputs/PeopleChips';
import { fetchSearchSegments } from '~src/services/fetch/fetchSearchSegments.service';
import useFocusFirstInput from '~src/services/hooks/useFocusFirstInput';
import CheckBox from '~src/shared/form/Checkbox';

import { FormCheckBoxes, FormInput, FormWrapper } from './customVisibilityForm.sc';

interface Props {
  selectedPeople: Segment[];
  managersChecked?: boolean;
  onChange: (args: { people: Segment[], shareWithManagers: boolean }) => void;
}

const CustomVisibilityForm: FC<Props> = props => {
  const { setInputRef } = useFocusFirstInput(true);

  const [people, setPeople] = useState(props.selectedPeople);
  const [changed, setChanged] = useState(false);
  const [managersChecked, setManagersChecked] = useState(props.managersChecked || false);

  const typedSearch = (value: string, cancelToken: CancelToken) =>
    fetchSearchSegments(value, cancelToken, [SegmentType.User, SegmentType.Group]);

  const onChangePeople = (param: Segment[]) => {
    setChanged(true);
    setPeople(param);
    props.onChange({ shareWithManagers: managersChecked, people: param });
  };

  const onChangeManagersCheckbox = (checked: boolean) => {
    setManagersChecked(checked);
    props.onChange({ shareWithManagers: checked, people });
  };

  const [t] = useTranslation();

  return (
    <FormWrapper>
      <FormInput>
        <PeopleChips
          setInputRef={setInputRef}
          fetchSuggestions={typedSearch}
          chipsName="people"
          selectedPeople={people}
          onChangePeople={onChangePeople}
          t={t}
          placeHolderKey="x.okrs.objective.visibility.chips.placeholder"
          error={changed && !managersChecked}
        />
      </FormInput>
      <FormCheckBoxes>
        <CheckBox
          id="owners"
          isChecked
          disabled
          labelKey="x.okr.objective.visibility.owners"
          label={t('x.okr.objective.visibility.owners')}
        />
        <CheckBox
          id="manager"
          isChecked={managersChecked}
          onChange={onChangeManagersCheckbox}
          labelKey="x.okr.objective.visibility.managers"
          label={t('x.okr.objective.visibility.managers')}
        />
      </FormCheckBoxes>
    </FormWrapper>
  );
};

export default CustomVisibilityForm;
